/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { DICTIONARY_TIMEZONES, MasterZoneRestService } from '@gh/builder-shared-data';
import {
  DictionaryService,
  getRouteParam, globalDictionaries,
  InitViewService,
  isRouteForCreationMode,
  UserContext,
} from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { Observable } from 'rxjs';
import { MasterZoneDetails } from './master-zone-details.model';
import { currentDate } from '@gh/core-util';

@Injectable()
export class MasterZoneDetailsBusinessService implements InitViewService {
  constructor(private masterZoneRest: MasterZoneRestService,
              private dictionaryService: DictionaryService,
              private userContext: UserContext) {

  }

  initView(route: ActivatedRouteSnapshot): any {
    const creationMode = isRouteForCreationMode(route);
    const masterZoneId = getRouteParam(route, 'masterZoneId');

    return {
      states: this.dictionaryService.get(globalDictionaries.states),
      masterZone: masterZoneId ? this.get(masterZoneId) : this.prepareForCreate(),
      creationMode,
      timeZones: this.dictionaryService.get(DICTIONARY_TIMEZONES),
    };
  }

  prepareForCreate(): MasterZoneDetails {
    return {
      id: '',
      code: '',
      name: '',
      active: true,
      timeZone: this.userContext.data.zoneId,
      billing: {
        // tslint:disable-next-line:no-null-keyword
        depositDate: null,
        // tslint:disable-next-line:no-null-keyword
        contractSignedDate: null,
        // tslint:disable-next-line:no-null-keyword
        commencementDate: null,
        term: 0,
        // tslint:disable-next-line:no-null-keyword
        renewalDate: null,
        taxRate: 0,
        // tslint:disable-next-line:no-null-keyword
        saleFee: null,
        saleFeeAmount: 0,
      },
    };
  }

  create(masterzone: MasterZoneDetails): Observable<MasterZoneDetails> {
    return this.masterZoneRest.create(masterzone);
  }

  update(masterzone: MasterZoneDetails): Observable<MasterZoneDetails> {
    return this.masterZoneRest.update(masterzone);
  }

  get(id: ID): Observable<MasterZoneDetails> {
    return this.masterZoneRest.get(id);
  }
}
